"use strict";
const supported = "speechSynthesis" in window && "SpeechSynthesisUtterance" in window;
const RATES = [1, 1.25, 1.5, 0.75];
const MAX_CHUNK = 220;
const STORE = "focasos-escuchar-velocidad";
let active = null;
let voice = null;
const readRate = () => {
  try {
    const stored = parseFloat(window.localStorage.getItem(STORE));
    return RATES.includes(stored) ? stored : 1;
  } catch (error) {
    return 1;
  }
};
const saveRate = (rate) => {
  try {
    window.localStorage.setItem(STORE, String(rate));
  } catch (error) {
  }
};
const pickVoice = () => {
  const voices = window.speechSynthesis.getVoices();
  voice = voices.find((item) => item.lang === "es-ES") || voices.find((item) => item.lang.toLowerCase().startsWith("es")) || null;
};
const chunksOf = (text) => {
  const sentences = text.replace(/\s+/g, " ").trim().split(new RegExp("(?<=[.;:!?])\\s+"));
  const chunks = [];
  sentences.forEach((sentence) => {
    let rest = sentence.trim();
    while (rest.length > MAX_CHUNK) {
      const cut = rest.lastIndexOf(" ", MAX_CHUNK) > 0 ? rest.lastIndexOf(" ", MAX_CHUNK) : MAX_CHUNK;
      chunks.push(rest.slice(0, cut));
      rest = rest.slice(cut).trim();
    }
    if (rest) {
      chunks.push(rest);
    }
  });
  return chunks;
};
const textOf = (host) => {
  var _a, _b, _c, _d;
  if (host.matches(".focasos-accion")) {
    const step = host.closest(".response-questionnaire__step-heading");
    const title2 = (_a = step == null ? void 0 : step.querySelector("h2, h3")) == null ? void 0 : _a.textContent.trim();
    return [title2, (_b = host.querySelector(".focasos-accion__texto")) == null ? void 0 : _b.textContent.trim()].filter(Boolean).join(". ");
  }
  const title = (_c = host.querySelector(".proposal-participatory__title")) == null ? void 0 : _c.textContent.trim();
  return [title, (_d = host.querySelector(".proposal-participatory__text")) == null ? void 0 : _d.textContent.trim()].filter(Boolean).join(". ");
};
const el = (tag, className, text) => {
  const node = document.createElement(tag);
  if (className) {
    node.className = className;
  }
  if (text) {
    node.textContent = text;
  }
  return node;
};
const button = (label) => {
  const node = el("button", "focasos-escuchar__boton", label);
  node.type = "button";
  return node;
};
const build = (host, mount) => {
  const wrapper = el("span", "focasos-escuchar");
  const play = button("Escuchar");
  play.setAttribute("aria-label", "Escuchar esta acci\xF3n en voz alta");
  const pause = button("Pausa");
  const stop = button("Parar");
  const speed = button("");
  const status = el("span", "sr-only");
  status.setAttribute("role", "status");
  [pause, stop, speed].forEach((node) => {
    node.hidden = true;
  });
  wrapper.append(play, pause, stop, speed, status);
  mount.append(wrapper);
  const state = { host, chunks: [], index: 0, rate: readRate(), token: 0, paused: false, play, pause, stop, speed, status };
  const showRate = () => {
    speed.textContent = `Velocidad ${state.rate}\xD7`.replace(".", ",");
    speed.setAttribute("aria-label", `Velocidad de lectura ${state.rate} veces. Pulsa para cambiarla`);
  };
  showRate();
  const idle = (message) => {
    state.token += 1;
    state.paused = false;
    play.hidden = false;
    [pause, stop, speed].forEach((node) => {
      node.hidden = true;
    });
    status.textContent = message || "";
    if (active === state) {
      active = null;
    }
  };
  state.idle = idle;
  const speak = () => {
    const chunk = state.chunks[state.index];
    if (chunk === void 0) {
      idle("Lectura terminada");
      return;
    }
    state.token += 1;
    const token = state.token;
    const utterance = new window.SpeechSynthesisUtterance(chunk);
    utterance.lang = (voice == null ? void 0 : voice.lang) || "es-ES";
    if (voice) {
      utterance.voice = voice;
    }
    utterance.rate = state.rate;
    utterance.onend = () => {
      if (token === state.token) {
        state.index += 1;
        speak();
      }
    };
    utterance.onerror = (event) => {
      if (token === state.token && event.error !== "interrupted" && event.error !== "canceled") {
        idle("No se ha podido leer en voz alta en este navegador.");
      }
    };
    window.speechSynthesis.speak(utterance);
  };
  const start = () => {
    if (active && active !== state) {
      active.idle();
    }
    window.speechSynthesis.cancel();
    pickVoice();
    state.chunks = chunksOf(textOf(host));
    state.index = 0;
    state.paused = false;
    active = state;
    play.hidden = true;
    [pause, stop, speed].forEach((node) => {
      node.hidden = false;
    });
    pause.textContent = "Pausa";
    status.textContent = voice ? "Leyendo" : "Leyendo con la voz por defecto de tu navegador: no tiene una voz en castellano";
    speak();
  };
  play.addEventListener("click", start);
  stop.addEventListener("click", () => {
    window.speechSynthesis.cancel();
    idle("Lectura parada");
  });
  pause.addEventListener("click", () => {
    if (state.paused) {
      state.paused = false;
      pause.textContent = "Pausa";
      status.textContent = "Leyendo";
      speak();
    } else {
      state.paused = true;
      state.token += 1;
      window.speechSynthesis.cancel();
      pause.textContent = "Seguir";
      status.textContent = "En pausa";
    }
  });
  speed.addEventListener("click", () => {
    state.rate = RATES[(RATES.indexOf(state.rate) + 1) % RATES.length];
    saveRate(state.rate);
    showRate();
    if (!state.paused) {
      window.speechSynthesis.cancel();
      speak();
    }
  });
};
const init = () => {
  var _a, _b;
  if (!supported) {
    return;
  }
  pickVoice();
  (_b = (_a = window.speechSynthesis).addEventListener) == null ? void 0 : _b.call(_a, "voiceschanged", pickVoice);
  document.querySelectorAll(".focasos-accion").forEach((host) => {
    const mount = host.querySelector(".focasos-accion__debate");
    if (mount && !host.querySelector(".focasos-escuchar")) {
      build(host, mount);
    }
  });
  document.querySelectorAll("section.proposal-participatory__section").forEach((host) => {
    const mount = host.querySelector(":scope > .flex");
    if (mount && host.querySelector(".proposal-participatory__text") && !host.querySelector(".focasos-escuchar")) {
      build(host, mount);
    }
  });
};
window.addEventListener("pagehide", () => {
  if (supported) {
    window.speechSynthesis.cancel();
  }
});
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
